import { IOrdersState } from '../../types/interfaces'
import { ActionType } from '../actions/actionTypes'
import initialState from '../reducers/initialState'

export default function ordersReducer(
  state = initialState.orders as IOrdersState,
  action: any
): IOrdersState {
  switch (action.type) {
    case ActionType.LOAD_SUPPLIER_WORKFLOW_CONFIGS_SUCESS:
      return { ...state, supplierWorkflowsConfigs: action.supplierWorkflowsConfigs }
    case ActionType.LOAD_WORKFLOW_CONFIGS_SUCESS:
      return { ...state, workflowsConfigs: action.workflowsConfigs }
    case ActionType.LOAD_ORDER_FORMS_SUCESS:
      return { ...state, forms: action.forms }
    case ActionType.LOAD_ORDER_FORMS_IN_PROGRESS:
      return { ...state, formsLoadInProgress: action.formsLoadInProgress }
    case ActionType.LOAD_ORDERS_SUCESS:
      return { ...state, data: action.orders }
    case ActionType.SUBMIT_ORDER_SUCESS:
      return { ...state, data: action.orders }
    case ActionType.SUBMIT_APPROVAL_SUCESS:
      return { ...state, approvalProcess: action.process }
    case ActionType.SUBMIT_APPROVAL_SUCESS:
      return { ...state, approvalProcess: action.process }
    case ActionType.LOAD_TENANT_FUEL_CARD_SETS_SUCESS:
      return { ...state, tenantFuelCardSets: action.tenantFuelCardSets }
    case ActionType.DELETE_TENANT_FUEL_CARD_SET_SUCESS:
      return {
        ...state,
        tenantFuelCardSets: state.tenantFuelCardSets.filter((set) => set.id !== action.id),
      }
    case ActionType.LOAD_FUEL_CARDS_SUCESS:
      return { ...state, fuelCards: action.fuelCards }
    case ActionType.DELETE_FUEL_CARD_SUCESS:
      return {
        ...state,
        fuelCards: state.fuelCards.filter((fc) => fc.id !== action.id),
      }
    default:
      return state
  }
}
